export default "__VITE_ASSET__gWYdhuK1__"